export const YOUTUBE = "youtube";
export const VIMEO = "vimeo";
export const WISTIA = "wistia";
export const VIDYARD = "vidyard";
